export default __webpack_public_path__ + "static/favicon-06f21e77549f37ab2934d0049b393ba9.png";